import DeviceAlarmsTable from "./DeviceAlarmsTable";

export default DeviceAlarmsTable